import React, { useState, useCallback, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import BottomBar from "./BottomBar";
import EditorSubmitButtons from "./EditorSubmitButtons";
import TopBar from "./TopBar";
import EditorExtraTabs from "./editorExtraTabs";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import _debounce from 'lodash/debounce';
import { sendQuestionDraftData } from "../../API/api";
import Styles from './EditorStyles.module.css';
import AllModals from "../Modals/allModals";

Quill.register("modules/imageResize", ImageResize);

function TextEditor() {
  // const [iscallApi, setIsCallApi] = useState(false);
  const dispatch = useDispatch();
  const {updateAnswerTextForEditor,updateButtonEnableForEditor, advanceFilterModalToggle } = bindActionCreators(Actions,dispatch )
  const editorState = useSelector(state=>state.editor);
  const debounceFn = useCallback(_debounce(handleDebounceFn, 7000), []);

    function handleDebounceFn(inputValue) {
     if(inputValue !== ''){
      let payload = {
        questionUuid:editorState.data.questionUuid,
        answer:inputValue,
        uploadFiles:[]
      }
      sendQuestionDraftData(payload).then(res=>{
      })
     }
    }

  const updateText = (event) => {
    let pureStr = event.replace(/<[^>]*>?/gm, '');
    updateButtonEnableForEditor(pureStr === '' ?true:false)
    updateAnswerTextForEditor(event);
    if(pureStr !== ""){
      debounceFn(event);
    }
  };
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
    clipboard: {
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };
  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];
  const getBase64=(file, cb)=>{
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
    };
}

  const attachmentsData = (file) =>{
    advanceFilterModalToggle({ bool: true, value: "addAttachmentCaption" });
    getBase64(file,(result)=>{
        var size =
          file.size / (1024 * 1024) > 1
            ? file.size / (1024 * 1024) + " mB"
            : file.size / 1024 + " kB";
        let data = {
          caption: "",
          name: file.name,
          size: size,
          type: file.type,
          src: result,
          show: 1,
          isThumbNail: false,
        };
        editorState.attachments.push(data);
      })
  }
  useEffect(()=>{

  },[editorState.answerText])
  return (
    <>
      <div>
        <div className="mb-2">
        <TopBar/>
        </div>
        <input type="file" id="actual-btn" onChange={(e)=>attachmentsData(e.target.files[0])} style={{display: "none"}}   name="files" required="" maxsize="500"  aria-invalid="true"></input>
        <label className={`${Styles.attachmentButtonAdded}`} for="actual-btn">
        <i className={`${Styles.attachmentButtonAddedinline} fa fa-paperclip`}></i>
        </label>
        <ReactQuill
          theme="snow"
          value={editorState.answerText}
          modules={modules}
          formats={formats}
          onChange={(e) => updateText(e)}
        />
        <BottomBar />
        <EditorSubmitButtons/>
        <br/><br/>
        <EditorExtraTabs/>
      </div>
      <AllModals/>
    </>
  );
}

export default TextEditor;
